module.exports = __webpack_public_path__ + "img/y-3.38f16bab.jpg";